import React from 'react';

export default function ToggleSwitch({ name, checked, ...props }) {
  return (
    <div className='toggle-switch'>
      <input
        type='checkbox'
        className='toggle-switch-checkbox'
        checked={checked}
        name={name}
        id={name}
        {...props}
      />
      <label className='toggle-switch-label' htmlFor={name}>
        <span className='toggle-switch-inner' />
        <span className='toggle-switch-switch' />
      </label>
    </div>
  );
}
